// extracted by mini-css-extract-plugin
module.exports = {"main-color-default":"#14afff","red":"#e11960","green":"#0acf83","pink":"#e94e77","navy":"#4163d5"};